import { render, staticRenderFns } from "./materialTypeModal.vue?vue&type=template&id=34dabb9f&"
import script from "./materialTypeModal.vue?vue&type=script&lang=js&"
export * from "./materialTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./materialTypeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports